/**
 * @spec docs/specs/features/wallet-relation-api.md
 * @spec docs/specs/features/wallet-relations-replay-protection.md
 * Types for wallet relation API integration
 *
 * Re-exports shared types from @phnm/wallet-types.
 */

// Re-export all shared types and constants
export {
  // Types
  type LinkedWallet,
  type QueryRelationsResponse,
  type LinkWalletsResponse,
  type UnlinkWalletResponse,
  type SetLabelRequest,
  type SetLabelResponse,
  type WalletRelationError,
  type LinkWalletsRequest,
  type QueryRelationsRequest,
  type UnlinkWalletRequest,
  type HealthResponse,
  type CanonicalAddresses,
  type WalletNoncesResponse,
  // Constants
  EIP712_DOMAIN,
  LINK_WALLETS_TYPES,
  QUERY_RELATIONS_TYPES,
  UNLINK_WALLET_TYPES,
  SET_LABEL_TYPES,
  // Utilities
  canonicalOrder,
  isValidAddress,
} from '@phnm/wallet-types';

// Legacy alias for backward compatibility
export { EIP712_DOMAIN as WALLET_RELATIONS_EIP712_DOMAIN } from '@phnm/wallet-types';

// Combined type export for convenience (mirrors structure of individual exports)
// These must match QUERY_RELATIONS_TYPES and UNLINK_WALLET_TYPES from the shared package
export const EIP712_TYPES = {
  LinkWallets: [
    { name: 'walletA', type: 'address' },
    { name: 'walletB', type: 'address' },
  ],
  QueryRelations: [
    { name: 'wallet', type: 'address' },
    { name: 'timestamp', type: 'uint256' },
    { name: 'nonce', type: 'uint256' },
  ],
  UnlinkWallet: [
    { name: 'wallet', type: 'address' },
    { name: 'timestamp', type: 'uint256' },
    { name: 'nonce', type: 'uint256' },
  ],
  SetLabel: [
    { name: 'wallet', type: 'address' },
    { name: 'targetWallet', type: 'address' },
    { name: 'label', type: 'string' },
    { name: 'timestamp', type: 'uint256' },
  ],
} as const;
